import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SCREEN_SIZE } from '../../../style';

const StyledJapanShippingStatisticsList = styled.div`
  ${SCREEN_SIZE.LG} {
    display: flex;
    width: 100%;
  }
`;

const ListSectionList = ({
  data,
  component,
}) => {
  const Comp = component;
  return (
    <StyledJapanShippingStatisticsList>
      { data.map((dataItem, index) => <Comp key={`comp-${index}`} data={dataItem} />)}
    </StyledJapanShippingStatisticsList>
  );
};

ListSectionList.propTypes = {
  // eslint-disable-next-line
  data: PropTypes.array.isRequired,
  component: PropTypes.func.isRequired,
};

export { ListSectionList };